export default "__VITE_ASSET__DFilix9z__"